import PostProcessingAction from 'interfaces/postProcessingAction';
import { apiRequestHandlerPromise } from 'utils/apiRequestHandler';

export const getPostProcessingActions = (stringParams: string) => {
  return apiRequestHandlerPromise<[PostProcessingAction]>({
    url: `post_processing_actions?${stringParams}`,
    method: 'GET',
  });
};
